/**
 * Builds statusList for filtered list API requests.
 * Omits statusList when all non-deleted statuses are selected (backend already excludes DELETED).
 */
export function buildStatusListForRequest(selectedStatuses, allNonDeletedStatuses) {
  if (!Array.isArray(selectedStatuses) || selectedStatuses.length === 0) {
    return undefined;
  }

  const allSelected =
    allNonDeletedStatuses.length > 0 &&
    selectedStatuses.length === allNonDeletedStatuses.length &&
    allNonDeletedStatuses.every((status) => selectedStatuses.includes(status));

  if (allSelected) {
    return undefined;
  }

  return selectedStatuses;
}
